import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { objectNotNullV2 } from '@/Utils/FnUtils';
import { handleResponseThrowError } from '@/_utils/services';
import { apiClient } from '@/_config/lib/axios/api-client';
import type { BaseRequestResponse } from '@/_types/services';
import type { CityGeneralApi } from '../types';

export const GET_CITIES_GENERAL_API = 'GET_CITIES_GENERAL_API';

export type GetCitiesGeneralApiParams = {
  cityName: string;
};

const getCitiesGeneralApi = (params: GetCitiesGeneralApiParams) => {
  const { cityName } = params;

  return apiClient
    .get<BaseRequestResponse<CityGeneralApi>>(`/municipios/api-geral-by-name`, {
      params: objectNotNullV2({ cityName }),
    })
    .then(response => response.data)
    .catch(handleResponseThrowError());
};

type GetCitiesGeneralApiResponse = Awaited<
  ReturnType<typeof getCitiesGeneralApi>
>;

export const useGetCitiesGeneralApi = (
  params: GetCitiesGeneralApiParams,
  options: Omit<
    UseQueryOptions<
      GetCitiesGeneralApiResponse,
      unknown,
      GetCitiesGeneralApiResponse,
      (string | GetCitiesGeneralApiParams)[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) => {
  return useQuery({
    queryKey: [GET_CITIES_GENERAL_API, params],
    queryFn: () => getCitiesGeneralApi(params),
    ...options,
  });
};
